/**
 * @generated SignedSource<<b2b5e2b1390947ebe31c6e6ea5a56034>>
 * @relayHash c3c465f8a459dc7491b4e4a8eae7839c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 985759d3ae3a2c9abd4eaaab23c29b0b1bb53e14207151f087a6aeb785f2614a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareTimelineAppQuery } from './JiraSoftwareTimelineAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareTimelineAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "985759d3ae3a2c9abd4eaaab23c29b0b1bb53e14207151f087a6aeb785f2614a",
    "metadata": {},
    "name": "JiraSoftwareTimelineAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
